import script from "./CoursePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursePage.vue?vue&type=script&setup=true&lang=js"

import "./CoursePage.vue?vue&type=style&index=0&id=4e1c74f4&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1c74f4"]])

export default __exports__